import DestinationFolder from './DestinationFolder';

export default DestinationFolder;
